export default "<span (click)=\"openEnd()\"><ion-icon name=\"menu-outline\" ></ion-icon></span>\n"